<template>
    <div class="history">
        <h3>{{selected_asset_name}} Transaction History</h3>
        <div class="history-filter">
            <el-date-picker
                v-model="daterange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="to"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                ref="picker"
                :picker-options="pickerOptions"
            ></el-date-picker>
        </div>
        <el-table
            :data="history"
            style="width: 100%"
            :max-height="tableHeightMax"
            cell-class-name="history-item"
            v-loading="processing"
            @filter-change="onFilter"
            stripe
        >
            <el-table-column label="Time" width="180" fixed="left">
                <template slot-scope="scope">{{scope.row.updated | formatDate}}</template>
            </el-table-column>
            
            <el-table-column label="Available" min-width="180">
                <template slot-scope="scope">
                    {{scope.row.fund_available}}
                    <span v-if="scope.row.variation_available!=0">
                        (
                        <span v-if="scope.row.variation_available>0">+</span>
                        {{scope.row.variation_available}})
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="180">
                <template slot="header">
                    <i class="el-icon-lock"></i>
                    <span>Locked</span>
                </template>
                <template slot-scope="scope">
                    {{scope.row.fund_lock}}
                    <span v-if="scope.row.variation_lock!=0">
                        (
                        <span v-if="scope.row.variation_lock>0">+</span>
                        {{scope.row.variation_lock}})
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                :filters="typeOptions"
                column-key="category"
                prop="category"
                label="Category"
                width="110"
            ></el-table-column>
            <el-table-column
                column-key="reference_id"
                prop="reference_id"
                label="Ref. ID"
                width="80"
            ></el-table-column>
            <el-table-column label="Note" prop="note" min-width="450" :show-overflow-tooltip="true">
                <!-- <template slot-scope="scope">
                    <el-popover
                        placement="top-start"
                        :title="scope.row.updated | formatDate"
                        trigger="hover"
                        :content="scope.row.note"
                    >
                        <div slot="reference">{{scope.row.note}}</div>
                    </el-popover>
                </template> -->
            </el-table-column>
        </el-table>
        <div class="load-more" @click="loadMore" v-if="history.length<total">more...</div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
    name: "BalanceHistory",
    props: {
        selected_asset_name: { default: null },
        authenticate_id: { type: Number, default: null }
    },
    data() {
        return {
            daterange: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "1 week",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "1 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "3 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            filter_str: "",
            history: [],
            processing: false,
            total: 0,
            skip: 0
        };
    },
    mounted() {
        let end = new Date();
        let start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.daterange = [start, end]
        this.$refs.picker.$emit('pick', [start, end]);
        this.history = [];
        // this.loadData();
    },
    components: {},
    watch: {
        selected_asset_name(newName, oldName) {
            if (newName != oldName) {
                this.history = [];
                this.skip = 0;
                this.total = 0;
                this.loadData();
            }
        },
        daterange() {
            this.loadData();
        }
    },
    computed: {
        tableHeightMax() {
            return window.innerHeight - 71;
        },
        startDate() {
            if(this.daterange && this.daterange[0]) {
                return moment(this.daterange[0]).format('YYYY-MM-DD 00:00:00');
            }
            return null
        },
        endDate() {
            if(this.daterange && this.daterange.length > 1 && this.daterange[1]) {
                return moment(this.daterange[1]).add(1, 'days').format('YYYY-MM-DD 00:00:00');
            }
            return null
        },
        typeOptions() {
            return [
                { text: "WITHDRAW", value: "WITHDRAW" },
                { text: "DEPOSIT", value: "DEPOSIT" },
                { text: "TRANSFER", value: "TRANSFER" },
                { text: "EXCHANGE", value: "EXCHANGE" },
                { text: "OTHERS", value: "OTHERS" }
            ];
        },
    },
    methods: {
        ...mapActions(["request", "getError"]),
        onFilter(filters) {
            this.filter_str = "";
            for(let column in filters) {
                let filter_str = "";
                for(let filter of filters[column]){
                    if(filter_str.length > 0) { filter_str += ` OR ` }
                    filter_str += `${column}='${filter}'`
                }
                if(filter_str.length > 0) {
                    if(this.filter_str.length > 0) {
                        this.filter_str += ` AND `
                    }
                    this.filter_str += ` (${filter_str}) `
                }
            }
            this.loadData();
            // filter_str
            // const property = column["property"];
            // return row[property] === value;
        },
        loadData(skip = 0, limit = 50, where=this.filter_str) {
            let ctrl = this;
            if(skip == 0) {
                ctrl.history = [];
            }
            ctrl.processing = true;
            let endpoint = `my/balance/history/${this.selected_asset_name}`;
            let params = {limit, skip};
            if(ctrl.startDate) {
                if(where.length > 0) { where += ` AND ` }
                where += ` updated >= '${ctrl.startDate}' `
            }
            if(ctrl.endDate) {
                if(where.length > 0) { where += ` AND ` }
                where += ` updated < '${ctrl.endDate}' `
            }
            params = { where }
            if (ctrl.authenticate_id) {
                endpoint = `authenticate/${this.authenticate_id}/balance/history/${this.selected_asset_name}`;
            }
            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    ctrl.total = data.total;
                    ctrl.skip += data.results.length;
                    ctrl.history = [...ctrl.history, ...data.results];
                })
                .catch(err => {
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        loadMore() {
            this.loadData(this.skip);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    padding: 0 16px;
}
.balance {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    cursor: pointer;
}

.balance[data-selected="false"]:hover {
    background-color:rgba(22, 124, 176, 0.2);
}

.balance[data-selected="true"] {
    background-color: #00517b;
}

.asset_name {
    line-height: 80px;
    padding: 0 20px;
    width: 60px;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 1.2em;
    background-color: rgba(0, 0, 0, 0.3);
}

.asset_balance {
    display: flex;
    flex-direction: column;
    line-height: 40px;
    flex: 1;
}

.asset_balance_available {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.asset_balance > div {
    padding: 0 10px;
}

.asset_balance_lock {
    color: #eee;
}

.history-item .el-table .cell {
    white-space: nowrap;
}
.history-filter {
    text-align: center;
    padding: 8px;
}
</style>
<style>
td.history-item {
    padding: 3px 0;
}
.history-item-variation {
    color: #ccc;
}
.history-item-variation-label {
    color: #909399;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #ccc;
    text-align: center;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}

.history-item .cell {
    white-space: nowrap;
}
</style>
